/*
    Changes made by NDean:
        Addition of baseUri parameter
        Changed loader.setCrossOrigin to "anonymous" instead of this.crossOrigin
        Rename parameters to reflect the fact that they use hashes
        Fix for vertex normals with a value of -1.#IND causing errors (replaced with 0)

    Changes made by EFrench
           addition of getHashUrl to locally compute the right CDN URL.
           removal of baseUri - now calculate the cdn bucket directly.
           removal of redirect from www in favor of directly going to CDN.
*/

/**
 * Loads a Wavefront .obj file with materials
 *
 * @author mrdoob / http://mrdoob.com/
 * @author angelxuanchang
 */

THREE.OBJMTLLoader = function () { };

THREE.OBJMTLLoader.prototype = {
    constructor: THREE.OBJMTLLoader,

    getHashUrl: function (hash) {
        var st = 31;
        for (var ii = 0; ii < 32; ii++) {
            st ^= hash[ii].charCodeAt(0);
        }
        return 'https://t' + (st % 8).toString() + '.rbxcdn.com/' + hash;
    },

    loadWithRetries: function (xhrLoader, url, onSuccess, onProgress, onError) {
        var retries = 0;
        var maxRetries = 4;
        var retryWait = 5 * 1000;

        function onLoadError() {
            if (retries < maxRetries) {
                retries = retries + 1;
                setTimeout(doLoad, retryWait);
            } else {
                onError("Unable to load file", url);
            }
        }

        function doLoad() {
            xhrLoader.load(url, onSuccess, onProgress, onLoadError);
        }

        doLoad();
    },

    interpretData: function(objMtlLoader, data, onComplete) {
        var scope = this;
        var xhrLoader = new THREE.FileLoader(scope.manager);

        function isHash(data) {
            return data.length === 32 && data.indexOf('/') === -1;
        }
        function isUrl(data) {
            return !isHash(data) && data.indexOf('/') > -1 && data.indexOf('\n') === -1;
        }
        function isMtlData(data) {
            return !isHash(data) && !isUrl(data);
        }
        if (isHash(data)) {
            this.loadWithRetries(xhrLoader, this.getHashUrl(data), function (res) {
                onComplete(objMtlLoader, res);
            }, function () { }, function onError() {
            });
        }else if (isUrl(data)) {
            this.loadWithRetries(xhrLoader, data, function (res) {
                onComplete(objMtlLoader, res);
            }, function () { }, function onError() {
            });
        }else if (isMtlData(data)) {
            onComplete(objMtlLoader,data);
        }
    },

    cleanObjData: function(data) {
        //hack to get rid of -1.#IND problem with Ice Crown
        return data.replace(new RegExp("-1.#IND", 'g'), "0");
    },

    load: function (objHash, mtlHash, onLoad) {
        var mtl;
        var obj;
        var crossOriginValue = "anonymous";
        var mtlLoader = new THREE.MTLLoader({}, crossOriginValue);
        this.interpretData(this, mtlHash, function (objMtlLoader, mtlData) {
            mtl = mtlLoader.parse(mtlData);
            objMtlLoader.interpretData(objMtlLoader, objHash, function(objMtlLoader, objData) {
                obj = objMtlLoader.cleanObjData(objData);
                obj = objMtlLoader.parse(obj);
                obj.traverse(function (child) {
                    if (child instanceof THREE.Mesh) {
                        if (child.material.name) {
                            var submaterial = mtl.create(child.material.name);
                            if (submaterial) {
                                child.material = submaterial;
                            }
                        }
                    }
                });
                onLoad(obj, mtl);
            });
        });
    },
        

    /**
     * Parses loaded .obj file
     * @param data - content of .obj file
     * @param mtllibCallback - callback to handle mtllib declaration (optional)
     * @return {THREE.Object3D} - Object3D (with default material)
     */

    parse: function (data, mtllibCallback) {

        function vector(x, y, z) {
            return new THREE.Vector3(x, y, z);
        }

        function uv(u, v) {
            return new THREE.Vector2(u, v);
        }

        function face3(a, b, c, normals) {
            return new THREE.Face3(a, b, c, normals);
        }

        var face_offset = 0;

        function meshN(meshName, materialName) {
            if (vertices.length > 0) {
                geometry.vertices = vertices;
                geometry.mergeVertices();
                /* ROBLOX removal 
                geometry.computeCentroids();
                geometry.computeFaceNormals();
                geometry.computeBoundingSphere(); */
                object.add(mesh);
                geometry = new THREE.Geometry();
                mesh = new THREE.Mesh(geometry, material);
                verticesCount = 0;
            }

            if (meshName !== undefined) mesh.name = meshName;

            if (materialName !== undefined) {
                material = new THREE.MeshLambertMaterial();
                material.name = materialName;
                mesh.material = material;
            }
        }

        var group = new THREE.Object3D();
        var object = group;

        var geometry = new THREE.Geometry();
        var material = new THREE.MeshLambertMaterial();

        var mesh = new THREE.Mesh(geometry, material);

        var vertices = [];
        var verticesCount = 0;
        var normals = [];
        var uvs = [];

        function add_face(a, b, c, normals_inds) {
            if (normals_inds === undefined) {
                geometry.faces.push(face3(
                    parseInt(a) - (face_offset + 1),
                    parseInt(b) - (face_offset + 1),
                    parseInt(c) - (face_offset + 1)
                ));
            } else {
                geometry.faces.push(face3(
                    parseInt(a) - (face_offset + 1),
                    parseInt(b) - (face_offset + 1),
                    parseInt(c) - (face_offset + 1),
                    [
                        normals[parseInt(normals_inds[0]) - 1].clone(),
                        normals[parseInt(normals_inds[1]) - 1].clone(),
                        normals[parseInt(normals_inds[2]) - 1].clone()
                    ]
                ));
            }
        }

        function add_uvs(a, b, c) {
            geometry.faceVertexUvs[0].push([
                uvs[parseInt(a) - 1].clone(),
                uvs[parseInt(b) - 1].clone(),
                uvs[parseInt(c) - 1].clone()
            ]);
        }

        function handle_face_line(faces, uvs, normals_inds) {
            if (faces[3] === undefined) {
                add_face(faces[0], faces[1], faces[2], normals_inds);
                if (!(uvs === undefined) && uvs.length > 0) {
                    add_uvs(uvs[0], uvs[1], uvs[2]);
                }
            } else {
                if (!(normals_inds === undefined) && normals_inds.length > 0) {
                    add_face(faces[0], faces[1], faces[3], [normals_inds[0], normals_inds[1], normals_inds[3]]);
                    add_face(faces[1], faces[2], faces[3], [normals_inds[1], normals_inds[2], normals_inds[3]]);
                } else {
                    add_face(faces[0], faces[1], faces[3]);
                    add_face(faces[1], faces[2], faces[3]);
                }
                if (!(uvs === undefined) && uvs.length > 0) {
                    add_uvs(uvs[0], uvs[1], uvs[3]);
                    add_uvs(uvs[1], uvs[2], uvs[3]);
                }
            }
        }


        // v float float float
        var vertex_pattern = /v( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/;

        // vn float float float
        var normal_pattern = /vn( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/;

        // vt float float
        var uv_pattern = /vt( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/;

        // f vertex vertex vertex ...
        var face_pattern1 = /f( +\d+)( +\d+)( +\d+)( +\d+)?/;

        // f vertex/uv vertex/uv vertex/uv ...
        var face_pattern2 = /f( +(\d+)\/(\d+))( +(\d+)\/(\d+))( +(\d+)\/(\d+))( +(\d+)\/(\d+))?/;

        // f vertex/uv/normal vertex/uv/normal vertex/uv/normal ...
        var face_pattern3 = /f( +(\d+)\/(\d+)\/(\d+))( +(\d+)\/(\d+)\/(\d+))( +(\d+)\/(\d+)\/(\d+))( +(\d+)\/(\d+)\/(\d+))?/;

        // f vertex//normal vertex//normal vertex//normal ... 
        var face_pattern4 = /f( +(\d+)\/\/(\d+))( +(\d+)\/\/(\d+))( +(\d+)\/\/(\d+))( +(\d+)\/\/(\d+))?/
        //

        var lines = data.split("\n");

        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            line = line.trim();
            var result;
            if (line.length === 0 || line.charAt(0) === '#') {
                continue;

            } else if ((result = vertex_pattern.exec(line)) !== null) {
                // ["v 1.0 2.0 3.0", "1.0", "2.0", "3.0"]
                vertices.push(vector(
                    parseFloat(result[1]),
                    parseFloat(result[2]),
                    parseFloat(result[3])
                ));
            } else if ((result = normal_pattern.exec(line)) !== null) {
                // ["vn 1.0 2.0 3.0", "1.0", "2.0", "3.0"]
                normals.push(vector(
                    parseFloat(result[1]),
                    parseFloat(result[2]),
                    parseFloat(result[3])
                ));
            } else if ((result = uv_pattern.exec(line)) !== null) {
                // ["vt 0.1 0.2", "0.1", "0.2"]
                uvs.push(uv(
                    parseFloat(result[1]),
                    parseFloat(result[2])
                ));
            } else if ((result = face_pattern1.exec(line)) !== null) {
                // ["f 1 2 3", "1", "2", "3", undefined]
                handle_face_line([result[1], result[2], result[3], result[4]]);
            } else if ((result = face_pattern2.exec(line)) !== null) {
                // ["f 1/1 2/2 3/3", " 1/1", "1", "1", " 2/2", "2", "2", " 3/3", "3", "3", undefined, undefined, undefined]
                handle_face_line(
                    [result[2], result[5], result[8], result[11]], //faces
                    [result[3], result[6], result[9], result[12]] //uv
            );
            } else if ((result = face_pattern3.exec(line)) !== null) {
                // ["f 1/1/1 2/2/2 3/3/3", " 1/1/1", "1", "1", "1", " 2/2/2", "2", "2", "2", " 3/3/3", "3", "3", "3", undefined, undefined, undefined, undefined]
                handle_face_line(
                    [result[2], result[6], result[10], result[14]], //faces
                    [result[3], result[7], result[11], result[15]], //uv
                    [result[4], result[8], result[12], result[16]] //normal
        );
            } else if ((result = face_pattern4.exec(line)) !== null) {
                // ["f 1//1 2//2 3//3", " 1//1", "1", "1", " 2//2", "2", "2", " 3//3", "3", "3", undefined, undefined, undefined]
                handle_face_line(
                    [result[2], result[5], result[8], result[11]], //faces
                    [], //uv
                    [result[3], result[6], result[9], result[12]] //normal
    );
            } else if (/^o /.test(line)) {
                // object
                meshN();
                face_offset = face_offset + vertices.length;
                vertices = [];
                object = new THREE.Object3D();
                object.name = line.substring(2).trim();
                group.add(object);
            } else if (/^g /.test(line)) {
                // group
                meshN(line.substring(2).trim(), undefined);
            } else if (/^usemtl /.test(line)) {
                // material
                meshN(undefined, line.substring(7).trim());
            } else if (/^mtllib /.test(line)) {
                // mtl file
                if (mtllibCallback) {
                    var mtlfile = line.substring(7);
                    mtlfile = mtlfile.trim();
                    mtllibCallback(mtlfile);
                }
            } else if (/^s /.test(line)) {
                // Smooth shading
            } else {
                //THREE.OBJMTLLoader: Unhandled line
            }
        }

        //Add last object
        meshN(undefined, undefined);
        return group;
    }
};